var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Figma icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ads manager"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.72,
    height: 13.72,
    x: 5.64,
    y: 5.64,
    fill: "#525967",
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454b57",
    d: "M17.36 6.24a1.4 1.4 0 0 1 1.4 1.4v9.72a1.4 1.4 0 0 1-1.4 1.4H7.64a1.4 1.4 0 0 1-1.4-1.4V7.64a1.4 1.4 0 0 1 1.4-1.4h9.72m0-.6H7.64a2 2 0 0 0-2 2v9.72a2 2 0 0 0 2 2h9.72a2 2 0 0 0 2-2V7.64a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0acf83",
    d: "M10.79 17.63a1.71 1.71 0 0 0 1.71-1.71v-1.71h-1.71a1.71 1.71 0 1 0 0 3.42z",
    "data-name": "path0 fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a259ff",
    d: "M9.08 12.5a1.71 1.71 0 0 1 1.71-1.71h1.71v3.42h-1.71a1.71 1.71 0 0 1-1.71-1.71z",
    "data-name": "path1 fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f24e1e",
    d: "M9.08 9.08a1.71 1.71 0 0 1 1.71-1.71h1.71v3.42h-1.71a1.71 1.71 0 0 1-1.71-1.71z",
    "data-name": "path1 fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7262",
    d: "M12.5 7.38h1.71a1.71 1.71 0 1 1 0 3.42H12.5z",
    "data-name": "path2 fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1abcfe",
    d: "M15.92 12.5a1.71 1.71 0 1 1-1.71-1.71 1.71 1.71 0 0 1 1.71 1.71z",
    "data-name": "path3 fill"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h25v25H0z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.2a02823fbf8c88279a3ffbc10d86489e.svg";
export { ForwardRef as ReactComponent };